const BYTES_PER_MB = 1024 * 1024;

export interface StateSizeReport {
  /** UTF-16 string length used by JSON.stringify (bytes ≈ length × 2 in V8). */
  jsonBytes: number;
  jsonMb: number;
  /** Encrypted / raw string length when persisted to localStorage. */
  storageBytes: number;
  storageMb: number;
}

export function byteLengthUtf8(value: string): number {
  return new TextEncoder().encode(value).length;
}

export function bytesToMb(bytes: number): number {
  return bytes / BYTES_PER_MB;
}

export function measureJsonPayload(payload: unknown): { jsonBytes: number; jsonMb: number } {
  const serialized = JSON.stringify(payload);
  const jsonBytes = byteLengthUtf8(serialized);
  return { jsonBytes, jsonMb: bytesToMb(jsonBytes) };
}

export function buildStateSizeReport(jsonPayload: unknown, storageValue: string): StateSizeReport {
  const { jsonBytes, jsonMb } = measureJsonPayload(jsonPayload);
  const storageBytes = byteLengthUtf8(storageValue);
  return {
    jsonBytes,
    jsonMb,
    storageBytes,
    storageMb: bytesToMb(storageBytes),
  };
}

export function logStateStorageSizes(
  context: 'persist' | 'hydrate',
  report: StateSizeReport,
  extras?: { inMemoryMb?: number; storageKey?: string }
): void {
  const key = extras?.storageKey ?? 'ngrx-persist-v3';
  const inMemory = extras?.inMemoryMb != null ? ` | in-memory store ≈ ${extras.inMemoryMb.toFixed(3)} MB` : '';

  console.info(
    `[NgRx State] ${context} — persisted payload: ${report.jsonMb.toFixed(3)} MB (${report.jsonBytes.toLocaleString()} bytes JSON)` +
      ` | localStorage "${key}": ${report.storageMb.toFixed(3)} MB (${report.storageBytes.toLocaleString()} bytes encrypted)` +
      inMemory
  );
}
